import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { addLead } from '../../store/actions/dataLayer';
import {
  getPartyBrandedSRP,
  getPartyEnginesBrandedSRP
} from '../../utils/urlHelpers/party';
import Link from '../SEO/Link';
import { listingPropTypes } from '../../utils/commonPropTypes';
import { isManufacturerListing } from '../../utils/commonHelper';
import messages from '../../utils/translationMessages';

import './styles.css';
import { generateBrandedOemSearchPath } from '../../utils/urlHelpers/oem/generateBrandedOemSearchPath';
import { hyphenateUrlComponents } from '../../utils/urlHelpers/boats';

const DealerProducts = ({
  carouselLayout,
  intl: { formatMessage: t },
  listing,
  productType,
  addLead
}) => {
  const dealer = listing.owner;
  const isManufacturer = isManufacturerListing(listing.isOemModel);

  const getText = () => {
    if (productType === 'boat' && isManufacturer) {
      return t(messages.moreFromManufacturer);
    }

    if (productType === 'boat') {
      if (!carouselLayout) {
        return t(messages.dealerBoatsShort);
      }
      return t(messages.dealerBoats);
    }

    return t(messages.moreFromDealer);
  };

  return (
    <div
      id="dealer-action"
      className={classnames('dealer-action', {
        'carousel-layout': carouselLayout
      })}
    >
      {dealer && dealer.id && (
        <Link
          className="more-products-button"
          data-reporting-click-internal-link-id="more from this dealer"
          href={getHref(productType, dealer, listing)}
          onClick={() => {
            addLead(listing.id, 'view all inventory');
          }}
        >
          {getText()}
        </Link>
      )}
    </div>
  );
};

DealerProducts.defaultProps = {
  carouselLayout: false
};

DealerProducts.propTypes = {
  /** Tracking */
  addLead: PropTypes.func,
  /** Sets the layout for the BDP */
  carouselLayout: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  /** Listing information of the boat */
  listing: listingPropTypes,
  productType: PropTypes.string
};

// Gets the href for the "More from this dealer/broker/manufacturer" button
const getHref = (productType, dealer, listing) => {
  if (productType === 'boat') {
    if (listing.isOemModel) {
      return generateBrandedOemSearchPath(
        {},
        {
          page: 1,
          brand: hyphenateUrlComponents(listing.make)
        },
        true
      );
    }

    return getPartyBrandedSRP(dealer, listing.isOemModel, listing.make);
  }

  return getPartyEnginesBrandedSRP(dealer);
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      addLead
    },
    dispatch
  )
)(injectIntl(DealerProducts));
